import { useContext } from 'react';
import {
  FromNotificationsSetStateContext,
  FromNotificationsStateContext,
} from './provider';

export const useFromNotificationsState = () => {
  const context = useContext(FromNotificationsStateContext);
  if (context === undefined) {
    throw new Error(
      'useFromNotificationsState должен использоваться внутри FromNotificationsProvider'
    );
  }
  return context;
};

export const useFromNotificationsSetState = () => {
  const context = useContext(FromNotificationsSetStateContext);
  if (context === undefined) {
    throw new Error(
      'useFromNotificationsSetState должен использоваться внутри FromNotificationsProvider'
    );
  }
  return context;
};
